import createIcon from '../../createIcon';

/**
 * @component @name VideoFile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2LjAxQzQuOTEgMiA0LjAxIDIuODkgNC4wMSA0TDQgMjBDNCAyMS4xIDQuOSAyMiA2IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFY4TDE0IDJaTTEzIDlWMy41TDE4LjUgOUgxM1pNMTQgMTRMMTYgMTIuOTRWMTcuMDZMMTQgMTZWMTdDMTQgMTcuNTUgMTMuNTUgMTggMTMgMThIOUM4LjQ1IDE4IDggMTcuNTUgOCAxN1YxM0M4IDEyLjQ1IDguNDUgMTIgOSAxMkgxM0MxMy41NSAxMiAxNCAxMi40NSAxNCAxM1YxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoFile = createIcon('VideoFile', [
  [
    'path',
    {
      d: 'M14 2H6.01C4.91 2 4.01 2.89 4.01 4L4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM13 9V3.5L18.5 9H13ZM14 14L16 12.94V17.06L14 16V17C14 17.55 13.55 18 13 18H9C8.45 18 8 17.55 8 17V13C8 12.45 8.45 12 9 12H13C13.55 12 14 12.45 14 13V14Z',
      key: '1mqslu',
    },
  ],
]);

export default VideoFile;
